import React, {Component} from 'react';
import ReactTooltip from "react-tooltip";
import PropTypes from 'prop-types';

export default class InfoTooltip extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        return (
            <span>
                <span data-tip='' data-for={'tooltip_data'+this.props.label.replace(/[^a-zA-Z0-9]/g, '_')} data-place={this.props.right? 'right':'bottom'} className='tooltip_here'>
                    <span style={{fontWeight:'bold'}}>{this.props.label}</span> <i className={'fa fa-info-circle'} style={{color:'dodgerblue'}}></i>
                    </span>
                    <ReactTooltip id={'tooltip_data'+this.props.label.replace(/[^a-zA-Z0-9]/g, '_')}>
                        <div style={{fontWeight:'normal'}}>
                        {this.props.text}
                        </div>
                    </ReactTooltip>
            </span>
        );
    }
}

InfoTooltip.propTypes = {
    label: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    right: PropTypes.bool
}




// WEBPACK FOOTER //
// ./src/componentsTopsa/infoTooptip/InfoTooltip.js